/**
 * Zastareo wrapper — koristiti NotificationItem (variant="header") za red u header dropdown-u.
 */
import React, { useMemo } from 'react';
import NotificationItem from '@/shared/notifications/NotificationItem';
import { buildNotificationContext } from '@/shared/notifications/buildNotificationContext';

function HeaderNotificationDropdownRow({
  notification,
  loginOrganizations,
  obligationsInPreparation = [],
  obligations = [],
  organizations = [],
  organizationNameById = {},
  consultationByDocumentId = {},
  obligationProposalById = {},
  draftActionPlanId = null,
  implementationActionPlanId = null,
  completedActionPlanIds = [],
  extraObligations = [],
  isAdmin = false,
  onResolved,
  onModeratorAssignmentChanged,
  onLinkNavigate,
}) {
  const ctx = useMemo(
    () =>
      buildNotificationContext({
        isAdmin,
        loginOrganizations,
        obligations,
        obligationsInPreparation,
        organizations,
        organizationNameById,
        consultationByDocumentId,
        obligationProposalById,
        draftActionPlanId,
        implementationActionPlanId,
        completedActionPlanIds,
        extraObligations,
      }),
    [
      isAdmin,
      loginOrganizations,
      obligations,
      obligationsInPreparation,
      organizations,
      organizationNameById,
      consultationByDocumentId,
      obligationProposalById,
      draftActionPlanId,
      implementationActionPlanId,
      completedActionPlanIds,
      extraObligations,
    ]
  );

  return (
    <NotificationItem
      notification={notification}
      variant="header"
      ctx={ctx}
      onResolved={onResolved}
      onModeratorAssignmentChanged={onModeratorAssignmentChanged}
      onLinkNavigate={onLinkNavigate}
    />
  );
}

export default HeaderNotificationDropdownRow;
